import React, { useRef, useState } from "react";
import logo from "../../../images/logo.png";
import xs_logo from "../../../images/xs_logo.png";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Overlay from "../../Overlay";
import NavItems from "../../templates/NavItems";
import { useInView } from "framer-motion";
import "../../../App.css";


const NavBar = () => {
  const navBarRef = useRef(null);
  const isInView = useInView(navBarRef, { once: true });
  const navItems = ["Home", "About", "Projects", "Contact"];
  const [isDrawerOpen, setDrawerState] = useState(false);
  const handleDrawerState = () => {
    setDrawerState((prevState) => !prevState);
  }

  return (
    <Grid container id="Home-Navbar" ref={navBarRef}>
      <Grid item xs={0} sm={1}></Grid>
      <Grid item xs={12} sm={10} className={`${isInView ? "inview-header" : "animate-header"}`} id="navbar">
        <AppBar
          component="nav"
          className="grid-container"
        >
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "space-between",
              alignItems: "center",
            }}
            id="navbar-contents-md"
          >
            <img src={logo} alt="Niveditha" width="20%" id="navbar-logo-md"/>
            <NavItems id="navbar-items-md" content={navItems} title="NavItems_row" />
          </Box>
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "space-between",
              alignItems: "center",
            }}
            id="navbar-contents-xs"
          >
            <img
              src={xs_logo}
              alt="Niveditha"
              width="8.5%"
              style={{ minWidth: "50px" }}
              id="navbar-logo-xs"
            />
            <Box id="navbar-contents-xs">
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerState}
                id="navbar-items-xs"
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Box>
        </AppBar>
      </Grid>
      <Grid item xs={0} sm={1}></Grid>
      {isDrawerOpen ? (
        <Overlay
          title="NavItems_column"
          content={navItems}
          closeOverlay={handleDrawerState}
        />
      ) : (
        ""
      )}
    </Grid>
  );
};

export default NavBar;
